import type { ReactElement } from 'react';
import { TBody, TD, TR } from '@/components/ui/table';
import { Skeleton } from './Skeleton';
import { cn } from '@/lib/cn';

interface TableRowSkeletonProps {
  rows?: number;
  columns: number;
}

export function TableRowSkeleton({ rows = 5, columns }: TableRowSkeletonProps): ReactElement {
  return (
    <TBody>
      {Array.from({ length: rows }).map((_, r) => (
        <TR key={r}>
          {Array.from({ length: columns }).map((__, c) => (
            <TD key={c} className="py-3">
              <Skeleton className="h-4 w-full max-w-[180px]" />
            </TD>
          ))}
        </TR>
      ))}
    </TBody>
  );
}

interface CardSkeletonProps {
  count?: number;
  className?: string;
}

export function CardSkeleton({ count = 3, className }: CardSkeletonProps): ReactElement {
  return (
    <div
      className={cn(
        'grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4',
        className,
      )}
    >
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="rounded-lg border border-border bg-card p-4 shadow-sm"
          data-testid="card-skeleton"
        >
          <Skeleton className="mb-3 h-3 w-24" />
          <Skeleton className="h-7 w-32" />
        </div>
      ))}
    </div>
  );
}

export function FullPageLoading(): ReactElement {
  return (
    <div className="flex min-h-[40vh] items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-4 w-32" />
      </div>
    </div>
  );
}
